export default "__VITE_ASSET__0vEWrpzu__"